import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { DataStoreResourceType } from "../../../../../../utils/constants";
import { icons, logos } from "../../../icons/iconExport";
import { DataStoreResourceTypeIconsAndLabels } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

export default function GitHubRepositoryDetailsView({ entityData }) {
  const github_data = entityData?.github_data;

  if (!github_data) return null;

  const [, repository_label] = Object.keys(
    DataStoreResourceTypeIconsAndLabels
  ).includes(DataStoreResourceType.REPOSITORY)
    ? DataStoreResourceTypeIconsAndLabels[DataStoreResourceType.REPOSITORY]
    : [null, null];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Resource Type */}
      {entityData?.resource_type && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serverTypeIcon} width="16px" />
            <Typography variant="subtitle2">Resource Type</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={logos.GitHubLogo} width="16px" />
            <TextIntegrationStyle title="" value={repository_label} />
          </Box>
        </Box>
      )}
      {/* Repository URL */}
      {github_data.repo_url && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.LinkIcon} width="16px" />
            <Typography variant="subtitle2">Repository URL</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={github_data.repo_url}
              onClick={() => window.open(github_data.repo_url, "_blank")}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            />
          </Box>
        </Box>
      )}
      {/* Visibility */}
      {github_data.visibility && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.publicIcon} width="16px" />
            <Typography variant="subtitle2">Visibility</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            <TextIntegrationStyle title="" value={github_data.visibility} />
          </Box>
        </Box>
      )}
      {/* Private Status */}
      {github_data.is_private !== undefined && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.LockIcon} width="16px" />
            <Typography variant="subtitle2">Private</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            <TextIntegrationStyle
              title=""
              value={github_data.is_private ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
